import { render, staticRenderFns } from "./gfprize.vue?vue&type=template&id=e8b5c466&scoped=true"
import script from "./gfprize.vue?vue&type=script&lang=js"
export * from "./gfprize.vue?vue&type=script&lang=js"
import style0 from "./gfprize.vue?vue&type=style&index=0&id=e8b5c466&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b5c466",
  null
  
)

export default component.exports